import React from 'react';

const LandingRedirectHandler = ({ children }) => {
  return children;
};

export default LandingRedirectHandler;
